import type { WindowDescriptor } from '@krp/client-runtime'

import { CATALOG_SOURCE } from '../features/sync/model/types'
import type { SyncUiState } from '../reducer'

/** Окна пакета: адрес, подпись, место в меню — один раз (R11). Содержимое окна — binding приложения. */
export const SYNC_WINDOWS = {
  home: 'sync.home',
  divergences: 'sync.divergences',
  job: 'sync.job',
  init: 'sync.init',
  ignores: 'sync.ignores',
  priceMaps: 'sync.price-maps',
  schedule: 'sync.schedule',
  journal: 'sync.journal',
} as const

export const syncWindows: readonly WindowDescriptor<SyncUiState>[] = [
  {
    // Вход раздела: плитки источников и общего каталога со счётчиками. Пункт меню один — «Синхронизация» (RP-SYN8). Права
    // `platform:sync:view|apply|configure` проверяет служба на каждой ручке; без права окно показывает её отказ дословно.
    kind: SYNC_WINDOWS.home,
    scope: 'global',
    paths: ['/sync'],
    label: 'Синхронизация',
    menu: { group: 'settings', order: 15, icon: 'sync' },
  },
  {
    // Расхождения одного источника или общего каталога; фильтры и отметки — не часть адреса, адрес говорит, что открыто.
    kind: SYNC_WINDOWS.divergences,
    scope: 'global',
    paths: ['/sync/divergences/:source'],
    label: 'Расхождения',
    title: (params) => (params.source === CATALOG_SOURCE ? 'Расхождения общего каталога' : 'Расхождения источника'),
    size: 'full',
  },
  {
    kind: SYNC_WINDOWS.job,
    scope: 'global',
    paths: ['/sync/jobs/:job'],
    label: 'Ход задачи',
    size: 'lg',
  },
  {
    kind: SYNC_WINDOWS.init,
    scope: 'global',
    paths: ['/sync/init/:source'],
    label: 'Инициализация связей',
    size: 'lg',
  },
  {
    kind: SYNC_WINDOWS.ignores,
    scope: 'global',
    paths: ['/sync/ignores'],
    label: 'Не отслеживается',
    size: 'lg',
  },
  {
    kind: SYNC_WINDOWS.priceMaps,
    scope: 'global',
    paths: ['/sync/price-maps'],
    label: 'Сопоставление видов цен',
    size: 'lg',
  },
  {
    kind: SYNC_WINDOWS.schedule,
    scope: 'global',
    paths: ['/sync/schedule'],
    label: 'Ночная сверка',
    size: 'sm',
  },
  {
    kind: SYNC_WINDOWS.journal,
    scope: 'global',
    paths: ['/sync/journal'],
    label: 'Журнал синхронизации',
    size: 'lg',
  },
]
